/* PAKKS SITE RUNTIME (theme): header + footer behaviour on every page. Vanilla, no libraries, deferred. The HTML works without it.
   Lifted from the approved preview (site/shared/site.js + the inline nav script in the PDP builder) and adapted to Shopify.
   1. Desktop dropdowns [data-navmore]: one open at a time, Esc closes and returns focus, closes on focus-out / outside click
   2. Phone menu <header-drawer><details data-pk-drawer>: Esc closes and returns focus, link click / outside click closes
   3. Country selector <details data-pk-country>: same closing rules (the choice itself is a plain form submit)
   4. Footer sign-up form[data-pk-signup]: validates, sends the email to Klaviyo (client subscriptions API), shows the thank-you;
      falls back to Shopify's customer form if Klaviyo can't be reached
   5. One-line header (compact / collapsed fallbacks) + sticky header (.pk-header--sticky, pk pages): hides on scroll down,
      returns on scroll up (never while focus or a menu is inside it); keeps focused elements clear of it
   6. Cart count: listens for document event 'pk:cart-updated' {detail: {item_count}} (fire it from pk-cart.js after any change)
*/
(function () {
  'use strict';
  var root = document.documentElement;
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) root.classList.add('rx-rm');

  /* 1. dropdowns */
  $$('[data-navmore]').forEach(function (m) {
    if (m.__pk) return; m.__pk = true;
    var b = m.querySelector('button'), p = m.querySelector('ul');
    function set(o, f) { b.setAttribute('aria-expanded', o ? 'true' : 'false'); p.hidden = !o; if (!o && f) b.focus(); }
    b.addEventListener('click', function () {
      var o = b.getAttribute('aria-expanded') !== 'true';
      $$('[data-navmore] button[aria-expanded="true"]').forEach(function (x) { if (x !== b) x.click(); });
      set(o);
    });
    m.addEventListener('keydown', function (e) { if (e.key === 'Escape' && b.getAttribute('aria-expanded') === 'true') { e.preventDefault(); set(false, true); } });
    m.addEventListener('focusout', function (e) { if (e.relatedTarget && !m.contains(e.relatedTarget)) set(false); });
    document.addEventListener('click', function (e) { if (!m.contains(e.target)) set(false); });
  });

  /* 2 + 3. details-based panels */
  function closable(d, closeOnLink) {
    if (d.__pk) return; d.__pk = true;
    var s = d.querySelector('summary');
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { e.preventDefault(); d.open = false; s.focus(); } });
    if (closeOnLink) d.addEventListener('click', function (e) { if (e.target.closest('a')) d.open = false; });
    document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
    d.addEventListener('focusout', function (e) { if (d.open && e.relatedTarget && !d.contains(e.relatedTarget) && !d.closest('[data-pk-drawer]')) d.open = false; });
  }
  $$('details[data-pk-drawer]').forEach(function (d) { closable(d, true); });
  $$('details[data-pk-country]').forEach(function (d) { closable(d, false); });

  /* 4. footer sign-up */
  $$('form[data-pk-signup]').forEach(function (f) {
    if (f.__pk) return; f.__pk = true;
    var inp = f.querySelector('input[type=email]'), err = f.querySelector('.pdp-signup__err'), done = f.querySelector('.pdp-signup__done'), btn = f.querySelector('button[type=submit]');
    var company = f.getAttribute('data-klaviyo-company'), list = f.getAttribute('data-klaviyo-list'), sent = false;
    function fail(msg) { inp.setAttribute('aria-invalid', 'true'); err.textContent = msg || err.getAttribute('data-error'); inp.focus(); }
    function ok() {
      inp.removeAttribute('aria-invalid'); err.textContent = '';
      f.querySelector('.pdp-signup__row').hidden = true; f.querySelector('.pdp-signup__label').hidden = true;
      done.hidden = false; done.focus();
    }
    inp.addEventListener('input', function () { if (inp.getAttribute('aria-invalid') === 'true' && inp.checkValidity()) { inp.removeAttribute('aria-invalid'); err.textContent = ''; } });
    f.addEventListener('submit', function (e) {
      if (sent) return;   // native fallback submit in progress
      e.preventDefault();
      inp.value = inp.value.trim();
      if (!inp.value || !inp.checkValidity()) { fail(); return; }
      if (!company || !list || !window.fetch) { sent = true; f.submit(); return; }
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Footer sign-up (Pakks theme)',
          profile: { data: { type: 'profile', attributes: { email: inp.value, properties: { market: (window.PAKKS && window.PAKKS.market) || '' } } } }
        }, relationships: { list: { data: { type: 'list', id: list } } } } })
      }).then(function (r) {
        btn.disabled = false;
        if (r.ok || r.status === 202) ok(); else { sent = true; f.submit(); }
      }).catch(function () { btn.disabled = false; sent = true; f.submit(); });
    });
    if (!done.hidden) done.focus();   // returned from the Shopify fallback with posted_successfully
  });

  /* 5a. one-line header: if the desktop row (nav · logo · country · icons) doesn't fit, first show the country as a code only,
     then collapse to the menu button + drawer. Measured on load, on resize and once the web fonts are ready. */
  var hdrBox = document.querySelector('[data-pk-header]'), bar = hdrBox && hdrBox.querySelector('.pdp-header__bar');
  if (bar) {
    var fits = function () {
      var nav = bar.querySelector('.pdp-nav__list'), logo = bar.querySelector('.pdp-logo'), ic = bar.querySelector('.pk-hicons');
      if (!nav || !nav.getClientRects().length || !nav.lastElementChild) return true;
      var cs = getComputedStyle(bar), col = (bar.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - logo.getBoundingClientRect().width) / 2 - 8;
      var navW = nav.lastElementChild.getBoundingClientRect().right - nav.firstElementChild.getBoundingClientRect().left;
      return navW <= col && ic.scrollWidth <= col;
    };
    var fit = function () {
      hdrBox.classList.remove('pk-hdr--compact', 'pk-hdr--collapsed');
      if (fits()) return;
      hdrBox.classList.add('pk-hdr--compact');
      if (fits()) return;
      hdrBox.classList.add('pk-hdr--collapsed');
    };
    fit();
    var rz = 0; addEventListener('resize', function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(fit); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* 5b. sticky header (pk pages, when the section setting is on): hides on scroll down, returns on scroll up. Never hides while
     focus or an open menu is inside it. Keeps --pk-hdr-h current (scroll-padding), and if a focused element would sit under the
     showing header (WCAG 2.4.11), scrolls it clear. Reduced motion: CSS drops the slide, it just shows/hides. */
  var hdrEl = root.getAttribute('data-pk-mode') === 'pk' && document.querySelector('.pk-header--sticky'), hdr = hdrEl && (hdrEl.closest('.shopify-section') || hdrEl);
  if (hdr) {
    var lastY = window.scrollY, ticking = false;
    var setH = function () { root.style.setProperty('--pk-hdr-h', hdr.offsetHeight + 'px'); };
    var state = function () { var r = hdr.getBoundingClientRect(); root.setAttribute('data-pk-hdr', !hdr.classList.contains('is-hidden') && r.top <= 1 && window.scrollY > 0 ? 'shown' : 'off'); };
    var busy = function () { return hdr.contains(document.activeElement) || hdr.querySelector('details[open], [aria-expanded="true"]'); };
    var onScroll = function () {
      var y = window.scrollY, h = hdr.offsetHeight;
      if (Math.abs(y - lastY) > 4 || y <= h) {
        var hide = y > lastY && y > h * 2 && !busy();
        hdr.classList.toggle('is-hidden', !!hide);
        lastY = y;
      }
      ticking = false; state();
    };
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    addEventListener('resize', setH, { passive: true }); setH(); state();
    hdr.addEventListener('focusin', function () { hdr.classList.remove('is-hidden'); state(); });
    document.addEventListener('focusin', function (e) {
      var t = e.target; if (!t || hdr.contains(t) || !t.getBoundingClientRect) return;
      requestAnimationFrame(function () {
        if (hdr.classList.contains('is-hidden')) return;
        var hb = hdr.getBoundingClientRect().bottom, r = t.getBoundingClientRect();
        if (hb > 0 && r.top < hb + 4 && r.bottom > 0) window.scrollBy(0, r.top - hb - 12);
      });
    });
  }

  /* 6. cart count */
  document.addEventListener('pk:cart-updated', function (e) {
    var n = e && e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null; if (n === null) return;
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; });
    $$('[data-cart-label]').forEach(function (c) { c.textContent = 'Cart, ' + n + (n === 1 ? ' item' : ' items'); });
  });
})();
